import asset0 from "@public/assets/stop.svg"
import asset1 from "@public/assets/picto/Agency.svg"
import asset2 from "@public/assets/picto/Arrow.svg"
import asset3 from "@public/assets/picto/ArrowContinue.svg"
import asset4 from "@public/assets/picto/ArrowTurnLeft.svg"
import asset5 from "@public/assets/picto/ArrowTurnRight.svg"
import asset6 from "@public/assets/picto/ArrowUturnLeft.svg"
import asset7 from "@public/assets/picto/ArrowUturnRight.svg"
import asset8 from "@public/assets/picto/Attachment.svg"
import asset9 from "@public/assets/picto/BackArrow.svg"
import asset10 from "@public/assets/picto/BikeSpeedFast.svg"
import asset11 from "@public/assets/picto/BikeSpeedNormal.svg"
import asset12 from "@public/assets/picto/BikeSpeedSlow.svg"
import asset13 from "@public/assets/picto/BikeTypeBike.svg"
import asset14 from "@public/assets/picto/BikeTypeBss.svg"
import asset15 from "@public/assets/picto/BikeTypeNoBike.svg"
import asset16 from "@public/assets/picto/Boundary.svg"
import asset17 from "@public/assets/picto/Calendar.svg"
import asset18 from "@public/assets/picto/Chevron.svg"
import asset19 from "@public/assets/picto/CreditCard.svg"
import asset20 from "@public/assets/picto/Cross.svg"
import asset21 from "@public/assets/picto/CrossCircle.svg"
import asset22 from "@public/assets/picto/Departure.svg"
import asset23 from "@public/assets/picto/Distrib.svg"
import asset24 from "@public/assets/picto/DoubleArrows.svg"
import asset25 from "@public/assets/picto/Download.svg"
import asset26 from "@public/assets/picto/ETicket.svg"
import asset27 from "@public/assets/picto/ElectricalBikeToggle.svg"
import asset28 from "@public/assets/picto/Elevator.svg"
import asset29 from "@public/assets/picto/Enter.svg"
import asset30 from "@public/assets/picto/Exit.svg"
import asset31 from "@public/assets/picto/Fastest.svg"
import asset32 from "@public/assets/picto/FollowSigns.svg"
import asset33 from "@public/assets/picto/Geoloc.svg"
import asset34 from "@public/assets/picto/Heart.svg"
import asset35 from "@public/assets/picto/Information.svg"
import asset36 from "@public/assets/picto/Itinerary.svg"
import asset37 from "@public/assets/picto/ItineraryArrow.svg"
import asset38 from "@public/assets/picto/LogoVLS.svg"
import asset39 from "@public/assets/picto/MagnifyingGlass.svg"
import asset40 from "@public/assets/picto/MapOptionsStyleSwitch.svg"
import asset41 from "@public/assets/picto/MapOptionslight.png"
import asset42 from "@public/assets/picto/MapOptionsortho.png"
import asset43 from "@public/assets/picto/MaxElevation.svg"
import asset44 from "@public/assets/picto/MinElevation.svg"
import asset45 from "@public/assets/picto/Minus.svg"
import asset46 from "@public/assets/picto/MobileMenuModuleForm.svg"
import asset47 from "@public/assets/picto/ModeAll.svg"
import asset48 from "@public/assets/picto/ModeBike.svg"
import asset49 from "@public/assets/picto/ModeBus.svg"
import asset50 from "@public/assets/picto/ModeCar.svg"
import asset51 from "@public/assets/picto/ModeMetro.svg"
import asset52 from "@public/assets/picto/ModeTrain.svg"
import asset53 from "@public/assets/picto/ModeTramway.svg"
import asset54 from "@public/assets/picto/ModeWalking.svg"
import asset55 from "@public/assets/picto/ModuleStations.svg"
import asset56 from "@public/assets/picto/NoPMR.svg"
import asset57 from "@public/assets/picto/PMR.svg"
import asset58 from "@public/assets/picto/Parameters.svg"
import asset59 from "@public/assets/picto/Phone.svg"
import asset60 from "@public/assets/picto/Pin.svg"
import asset61 from "@public/assets/picto/Plus.svg"
import asset62 from "@public/assets/picto/PricesInfo.svg"
import asset63 from "@public/assets/picto/RightArrow.svg"
import asset64 from "@public/assets/picto/ServicePoint.svg"
import asset65 from "@public/assets/picto/ShoppingBasket.svg"
import asset66 from "@public/assets/picto/Star.svg"
import asset67 from "@public/assets/picto/StreetView.svg"
import asset68 from "@public/assets/picto/Success.svg"
import asset69 from "@public/assets/picto/TimeArrow.svg"
import asset70 from "@public/assets/picto/Timer.svg"
import asset71 from "@public/assets/picto/TrafficCircle.svg"
import asset72 from "@public/assets/picto/Tree.svg"
import asset73 from "@public/assets/picto/WalkSpeedFast.svg"
import asset74 from "@public/assets/picto/WalkSpeedNormal.svg"
import asset75 from "@public/assets/picto/WalkSpeedSlow.svg"
import asset76 from "@public/assets/picto/Walking.svg"
import asset77 from "@public/assets/picto/Warning.svg"
import asset78 from "@public/assets/picto/Wifi.svg"
export const assets = {
	["assets/stop.svg"]: asset0,
	["assets/Agency.svg"]: asset1,
	["assets/Arrow.svg"]: asset2,
	["assets/ArrowContinue.svg"]: asset3,
	["assets/ArrowTurnLeft.svg"]: asset4,
	["assets/ArrowTurnRight.svg"]: asset5,
	["assets/ArrowUturnLeft.svg"]: asset6,
	["assets/ArrowUturnRight.svg"]: asset7,
	["assets/Attachment.svg"]: asset8,
	["assets/BackArrow.svg"]: asset9,
	["assets/BikeSpeedFast.svg"]: asset10,
	["assets/BikeSpeedNormal.svg"]: asset11,
	["assets/BikeSpeedSlow.svg"]: asset12,
	["assets/BikeTypeBike.svg"]: asset13,
	["assets/BikeTypeBss.svg"]: asset14,
	["assets/BikeTypeNoBike.svg"]: asset15,
	["assets/Boundary.svg"]: asset16,
	["assets/Calendar.svg"]: asset17,
	["assets/Chevron.svg"]: asset18,
	["assets/CreditCard.svg"]: asset19,
	["assets/Cross.svg"]: asset20,
	["assets/CrossCircle.svg"]: asset21,
	["assets/Departure.svg"]: asset22,
	["assets/Distrib.svg"]: asset23,
	["assets/DoubleArrows.svg"]: asset24,
	["assets/Download.svg"]: asset25,
	["assets/ETicket.svg"]: asset26,
	["assets/ElectricalBikeToggle.svg"]: asset27,
	["assets/Elevator.svg"]: asset28,
	["assets/Enter.svg"]: asset29,
	["assets/Exit.svg"]: asset30,
	["assets/Fastest.svg"]: asset31,
	["assets/FollowSigns.svg"]: asset32,
	["assets/Geoloc.svg"]: asset33,
	["assets/Heart.svg"]: asset34,
	["assets/Information.svg"]: asset35,
	["assets/Itinerary.svg"]: asset36,
	["assets/ItineraryArrow.svg"]: asset37,
	["assets/LogoVLS.svg"]: asset38,
	["assets/MagnifyingGlass.svg"]: asset39,
	["assets/MapOptionsStyleSwitch.svg"]: asset40,
	["assets/MapOptionslight.png"]: asset41,
	["assets/MapOptionsortho.png"]: asset42,
	["assets/MaxElevation.svg"]: asset43,
	["assets/MinElevation.svg"]: asset44,
	["assets/Minus.svg"]: asset45,
	["assets/MobileMenuModuleForm.svg"]: asset46,
	["assets/ModeAll.svg"]: asset47,
	["assets/ModeBike.svg"]: asset48,
	["assets/ModeBus.svg"]: asset49,
	["assets/ModeCar.svg"]: asset50,
	["assets/ModeMetro.svg"]: asset51,
	["assets/ModeTrain.svg"]: asset52,
	["assets/ModeTramway.svg"]: asset53,
	["assets/ModeWalking.svg"]: asset54,
	["assets/ModuleStations.svg"]: asset55,
	["assets/NoPMR.svg"]: asset56,
	["assets/PMR.svg"]: asset57,
	["assets/Parameters.svg"]: asset58,
	["assets/Phone.svg"]: asset59,
	["assets/Pin.svg"]: asset60,
	["assets/Plus.svg"]: asset61,
	["assets/PricesInfo.svg"]: asset62,
	["assets/RightArrow.svg"]: asset63,
	["assets/ServicePoint.svg"]: asset64,
	["assets/ShoppingBasket.svg"]: asset65,
	["assets/Star.svg"]: asset66,
	["assets/StreetView.svg"]: asset67,
	["assets/Success.svg"]: asset68,
	["assets/TimeArrow.svg"]: asset69,
	["assets/Timer.svg"]: asset70,
	["assets/TrafficCircle.svg"]: asset71,
	["assets/Tree.svg"]: asset72,
	["assets/WalkSpeedFast.svg"]: asset73,
	["assets/WalkSpeedNormal.svg"]: asset74,
	["assets/WalkSpeedSlow.svg"]: asset75,
	["assets/Walking.svg"]: asset76,
	["assets/Warning.svg"]: asset77,
	["assets/Wifi.svg"]: asset78,
}
const handlers = new Set()
export const onAssetChange = handler => handlers.add(handler)
